<div class="body" *ngIf="formGroup" [formGroup]="formGroup">

    <div class="street-row">

        <mat-form-field class="street" [appearance]="appearance">
            <mat-label>Straße</mat-label>
            <input matInput placeholder="Straße ohne Hausnummer" formControlName="addressstreet" [readonly]="!editMode" />
            <button *ngIf="editMode" mat-icon-button [disabled]="doubletService.checkerVisible$|async" matSuffix (click)="doubletService.setDoubletCheckerVisible(true)" matTooltip="Dubletten suchen">
                <mat-icon>manage_search</mat-icon>
            </button>
        </mat-form-field>
    
        <mat-form-field class="housenumber" [appearance]="appearance">
            <mat-label>Hausnr.</mat-label>
            <input matInput placeholder="z.B. 7a" formControlName="addresshousenumber" [readonly]="!editMode" />
        </mat-form-field>

    </div>

    <div class="doublet-checker-wrapper" *ngIf="doubletService && (doubletService.checkerVisible$|async)">
        <app-doublet-checker></app-doublet-checker>
    </div>

    <mat-form-field class="width" [appearance]="appearance">
        <mat-label>Addresszusatz</mat-label>
        <input matInput placeholder="z.B. Hauseingang 2" formControlName="addressaddition" [readonly]="!editMode" />
    </mat-form-field>

    <div class="city-wrapper">

        <mat-form-field class="zip-code" [appearance]="appearance">
            <mat-label>Postleitzahl</mat-label>
            <input matInput placeholder="z.B. 01067" formControlName="addresszipcode" [readonly]="!editMode" />
        </mat-form-field>
    
        <mat-form-field class="city" [appearance]="appearance">
            <mat-label>Stadt</mat-label>
            <input matInput placeholder="z.B. Dresden" formControlName="addresscity" [readonly]="!editMode" />
        </mat-form-field>

    </div>

    <mat-form-field class="width" [appearance]="appearance">
        <div matPrefix *ngIf="countryFlagIcon" class="country-icon">
            <span class="flag-icon {{countryFlagIcon}} flag-icon-squared"></span>
        </div>
        <mat-label>Land</mat-label>
        <mat-select formControlName="addresscountry" [disabled]="!editMode">
            <mat-option *ngFor="let country of countries" [value]="country.name">
                <span class="flag-icon {{country.flagIcon}} flag-icon-squared" style="margin-right: 2px;"></span>
                {{country.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>